import React, {useEffect, useState} from "react";
import Axios from "axios";
import logo from "./logo.svg";
import {FaGithubSquare} from "react-icons/fa";
let Main = () => {
  let [projects, setProjects] = useState([]);

  /*  
  let dataUrl ="https://gist.githubusercontent.com/hrk00007/f97b13775434b0efba048c654817734d/raw/edfe4c7fe1cd9dc4fd112ffdeba1f26590b42937/projects.json";
  useEffect(()=>{
        Axios.get(dataUrl).then((response)=>{
            console.log(response.data)
            setProjects(response.data)
        }).catch((error)=>{
            console.log(error);
        })
    },[dataUrl]) */
  useEffect(() => {
    let dataUrl = "https://api.jsonbin.io/v3/b/64009238ebd26539d087f5c0";
    let config = {
      headers: {
        "X-Master-Key":
          "$2b$10$ipOOGdF7iehvrNha6Lxm2./rQFE1B6S3g5S91Vt5JIPT1s/QXIaOG",
      },
    };
    // console.log(process.env.REACT_APP_BASE_URL);
    Axios.get(process.env.REACT_APP_BASE_URL, config)
      .then((response) => {
        // console.log(response.data.record)
        setProjects(response.data.record);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <React.Fragment>
      {/* <pre>{JSON.stringify(projects)}</pre> */}
      <section className="upper-section">
        <div className="container">
          <div className="row upper">
            <div className="col-md-6 title ">
              <h1>100 Projects of JavaScript</h1>
              <p>
                Projects are the most practical way to learn any language, and I
                am participating in these 100 days of code challenege. Each
                Project will teach me and u a new Concept.
              </p>
              {/* <a href="https://github.com/hrk00007/50-Days-Of-React" target="_blank" rel="noreferrer" class="btn hero-btn">Github Repo</a> */}
              <a href="https://github.com/hrk00007/100-Days-Of-JavaScript">
                <button className="cta">
                  <span>
                    <i className="fab fa-github mr-2"></i>
                    Github Repo
                  </span>
                  <svg viewBox="0 0 13 10" height="10px" width="15px">
                    <path d="M1,5 L11,5"></path>
                    <polyline points="8 1 12 5 8 9"></polyline>
                  </svg>
                </button>
              </a>
            </div>
            <div className="col-md-6 image mb-3 d-flex justify-content-end align-items-center h-100">
              {/* <img src={logo} alt="" className="App-logo" /> */}
              <img
                src="https://media4.giphy.com/media/ln7z2eWriiQAllfVcn/giphy.gif?cid=6c09b952ml6descdjhsppev0i0zht2b1953p4b4v3zngq7rh&rid=giphy.gif&ct=s"
                alt=""
                className="App-logo"
              />
              {/* <img
                src="https://cdn.dribbble.com/users/2442115/screenshots/8699490/media/48bbda278683c7879bebd57f0e2f9271.gif"
                alt=""
              /> */}
            </div>
          </div>
        </div>
      </section>

      <section className="template">
        <div className="container-fluid">
          <div className="row container mx-auto ">
            {projects.length > 0 && (
              <React.Fragment>
                {projects.map((project) => {
                  return (
                    <div className="col-md-4 mt-5" key={project.id}>
                      <a href={project.link} className="text-dark">
                        <div className="card text-center rare-wind-gradient h-100">
                          <div className="card-header">
                            <img
                              src={project.image}
                              alt={project.name}
                              className="img-fluid rounded-square"
                            />
                          </div>
                          <div className="card-body">
                            <h3 className="mb-2">{project.name} </h3>
                            <h6>{project.description}</h6>
                          </div>
                          <div className="card-footer text-align-left">
                            {project.tags.map((tag) => (
                              <span
                                className="badge badge-success mr-2 p-2 mt-2"
                                key={tag}
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })}
              </React.Fragment>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Main;
